import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";

export default function Unsubscribe() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const [state, setState] = useState("working");
  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    api.post("/public/unsubscribe", { token }).then(() => setState("done")).catch(() => setState("error"));
  }, [params]);
  return (
    <div className="max-w-xl mx-auto px-5 py-20" data-testid="unsubscribe-page">
      <h1 className="text-3xl text-[#0F172A]">{t("popup.unsub_title")}</h1>
      <p className="mt-4 text-slate-600" data-testid={`unsubscribe-${state}`}>{t(`popup.unsub_${state}`)}</p>
    </div>
  );
}
